import React from "react";
import { Link } from "react-router-dom";
import HubHeader from "@/components/HubHeader";
import { useApp } from "@/context/AppContext";
import { getUi, getTiles } from "@/portal/portal";
import { downloadJourneyPdf, collectLocalAnswers } from "@/lib/api";
import Part2HubSection from "@/components/part2/Part2Hub";

function JourneyDownload({ lang, t }) {
  const [name, setName] = React.useState("");
  const [busy, setBusy] = React.useState(false);
  const run = async () => {
    setBusy(true);
    try {
      await downloadJourneyPdf({ name, answers: collectLocalAnswers(), lang });
    } finally { setBusy(false); }
  };
  return (
    <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center", marginTop: 10 }}>
      <input className="rbl-input" style={{ maxWidth: 260 }} placeholder={t("namePlaceholder")}
        value={name} onChange={(e) => setName(e.target.value)} data-testid="journey-name" />
      <button className="rbl-btn" onClick={run} disabled={busy} data-testid="journey-download">
        {busy ? "…" : t("downloadBtn")}
      </button>
    </div>
  );
}

const HERO = {
  en: { kicker: "RBL × MILLENNIUM · PARTICIPANT HUB", title: "Basic Leadership Training", org: "Millennium Print Group" },
  nl: { kicker: "RBL × MILLENNIUM · DEELNEMERS HUB", title: "Basis Leiderschapstraining", org: "Millennium Print Group" },
  bg: { kicker: "RBL × MILLENNIUM · ПОРТАЛ ЗА УЧАСТНИЦИ", title: "Базово обучение по лидерство", org: "Millennium Print Group" },
  uk: { kicker: "RBL × MILLENNIUM · ПОРТАЛ УЧАСНИКА", title: "Базове навчання лідерству", org: "Millennium Print Group" },
};

export default function Hub() {
  const { lang } = useApp();
  const t = getUi(lang);
  const tiles = getTiles(lang);
  const hero = HERO[lang] || HERO.en;

  return (
    <div className="rbl" data-testid="hub-page">
      <HubHeader />
      <div className="rbl-wrap" style={{ paddingTop: 48, paddingBottom: 40 }}>
        <div className="rbl-eyebrow">{hero.kicker}</div>
        <h1 className="rbl-h1">{hero.title}</h1>
        <div className="rbl-org">{hero.org}</div>
        <p className="rbl-intro">{t("heroSub")}</p>
      </div>

      <div className="rbl-wrap" style={{ paddingBottom: 40 }}>
        <h2 className="rbl-section-title">{t("the6Sessions")}</h2>
        <div className="rbl-grid">
          {tiles.map((s) => (
            <Link to={`/session/${s.number}`} className="rbl-card" key={s.number} data-testid={`session-tile-${s.number}`}>
              <span className="rbl-card-num">{String(s.number).padStart(2, "0")}</span>
              <span className="rbl-card-emoji">{s.icon}</span>
              <span className="rbl-card-title">{s.title}</span>
              <span className="rbl-card-meta">{s.subtitle}</span>
              <span className="rbl-card-cta">{t("openSession")}</span>
            </Link>
          ))}
        </div>
      </div>

      <Part2HubSection />

      <div className="rbl-wrap" style={{ paddingBottom: 24 }}>
        <Link to="/library" className="rbl-feature" style={{ display: "block", textDecoration: "none", color: "inherit" }} data-testid="library-card">
          <h3>🖼️ {t("libraryTileTitle")}</h3>
          <p>{t("libraryTileSub")}</p>
          <span className="rbl-card-cta">{t("openSession")}</span>
        </Link>
      </div>

      <div className="rbl-wrap" style={{ paddingBottom: 24 }}>
        <div className="rbl-feature green" data-testid="participant-app-card">
          <div className="rbl-eyebrow" style={{ marginBottom: 8 }}>🔐 {t("loginCardKicker")}</div>
          <h3>{t("loginCardTitle")}</h3>
          <p>{t("loginCardBody")}</p>
          <Link to="/login" className="rbl-btn green" data-testid="open-participant-app" style={{ marginTop: 10 }}>
            {t("loginCardCta")}
          </Link>
        </div>
      </div>

      <div className="rbl-wrap" style={{ paddingBottom: 36 }}>
        <div className="rbl-feature" data-testid="journey-card">
          <h3>{t("journeyTitle")}</h3>
          <p>{t("journeySub")}</p>
          <JourneyDownload lang={lang} t={t} />
          <p style={{ color: "#8a90a2", fontSize: 13, marginTop: 10 }}>{t("journeyHint")}</p>
        </div>
      </div>

      <div className="rbl-wrap rbl-footer">
        <div>{t("footerText")}</div>
        <div style={{ marginTop: 10 }}>
          <Link to="/login" className="rbl-admin-link" data-testid="admin-login-link">{t("adminLogin")}</Link>
        </div>
      </div>
    </div>
  );
}
